import React, { useEffect, useState } from "react";
import {Container,Image,Form,Toast,ToastContainer,Row,Col} from "react-bootstrap";
import { Link, useNavigate } from "react-router-dom";
import {ViewOffSlashIcon,EyeIcon,CheckmarkBadge04Icon} from "../../assets/icons";
import { useDispatch} from "react-redux";
import CommonButton from "../../components/commonButton";
import RegisterLogo from "../../assets/images/login/shapes/login-logo.png";
import CommonFormLabel from "../../components/formLabel";
import Input from "../../components/input";
// import SearchableDropdown from "../../components/SearchableDropdown";
import "./Styles/Register.css";
import {registerUser,reqToGetAllBankList,reqToGetBranchList,reqToGetCityList,reqToGetStateList} from "../../redux/slice/authSlice";
import { Formik } from "formik";
import { registerSchema } from "../../schema/ValidationSchema";
import ValidationFeedback from "../../components/validationFeedback";
import SimpleDropdown from "../../components/simpleDropdown";
import useMounted from "../../hooks/useMounted";

const Register = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const hasMounted = useMounted();

  const [showToast, setShowToast] = useState(false);
  const [toastVariant, setToastVariant] = useState("toast-success");
  const [toastMessage, setToastMessage] = useState("");

  const [showEyeIcon, setShowEyeIcon] = useState(false);
  const [bankOptions, setBankOptions] = useState([]);
  const [branchOptions, setBranchOptions] = useState([]);
  const [stateList, setStateList] = useState([]);
  const [cityList, setCityList] = useState([]);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [selectedStateId, setSelectedStateId] = useState(null);
  // const [selectedBranchId, setSelectedBranchId] = useState(null);

  const initialEventState = {
    name: "",
    email: "",
    bank_id: "",
    branch_id: "",
    city: "",
    state: "",
    designation:"",
    phone: "",
    password: "",
  };

  // Api call to fetch all the banks & state list
  useEffect(() => {
    dispatch(reqToGetAllBankList({})).then((res) => {
      if (res?.payload?.success === true) {
        const list = res?.payload?.banks?.map((item) => ({
          value: item?.id,
          label: item?.bank_name,
        }));
        setBankOptions(list);
      }
    });

    dispatch(reqToGetStateList({})).then((res) => {
      if (res?.payload?.success === true) {
        const list = res?.payload?.states?.map((item) => ({
          value: item?.id,
          label: item?.name,
        }));
        setStateList(list);
      }
    });
  }, [dispatch]);

  // Api call to fetch branch & city list based on selected Bank and state
  useEffect(() => {
    if (selectedBankId !== null) {
      dispatch(reqToGetBranchList({ selectedBankId })).then((res) => {
        if (res?.payload?.success === true) {
          const list = res?.payload?.branches?.map((item) => ({
            value: item?.id,
            label: `${item?.branch_name} - (${item?.branch_city})`,
          }));
          setBranchOptions(list);
        }
      });
    }

    if (selectedStateId !== null) {
      dispatch(reqToGetCityList({ selectedStateId })).then((res) => {
        if (res?.payload?.success === true) {
          const list = res?.payload?.cities?.map((item) => ({
            value: item?.id,
            label: item?.name,
          }));
          setCityList(list);
        }
      });
    }
  }, [dispatch,selectedBankId, selectedStateId]);

  // Handler for registering User
  const handleSubmit = async (values, { setSubmitting }) => {
    try {
      const result = await dispatch(registerUser(values)).unwrap();
      if(result?.data?.success === true){
        setToastMessage(result?.message || "User registered successfully. Please wait for admin approval before you can log in to the bank portal.");
        setToastVariant("toast-success");
        setTimeout(() => {
          if (hasMounted) {
            navigate("/login", { replace: true });
          }
        }, 1000);
      }else{
        setToastMessage(result?.message || "Failed to register!");
        setToastVariant("toast-danger");
      }
    } catch (err) {
      const errorMessage = err?.message || "Failed to register!";
      setToastMessage(errorMessage);
      setToastVariant("toast-danger");
    } finally {
      setShowToast(true);
      setSubmitting(false);
    }
  };

  return (
    <>
      <ToastContainer position="top-end" className="p-3">
        <Toast
          onClose={() => setShowToast(false)}
          show={showToast}
          delay={4000}
          autohide
          bg={toastVariant}
          className="position-fixed top-3 end-0 me-3 shadow-none"
        >
          <Toast.Body className="d-flex align-items-center gap-1 lh-sm">
            <CheckmarkBadge04Icon
              width={18}
              height={18}
              color="#28c76f"
              strokeWidth="2"
            />
            <span className="text-capitalize">{toastMessage}</span>
          </Toast.Body>
        </Toast>
      </ToastContainer>
      <Container fluid="xxl" className="mx-auto px-4">
        <div className="d-flex align-items-center justify-content-center py-4 register-content">
          <div className="position-relative w-100 py-4 register-sub-content">
            <div className="bg-white rounded-2 p-5 common-shadow register-card">
              <h1 className="fs-5 d-flex align-content-center justify-content-center mb-4">
                <Link
                  to="https://mep.in/"
                  className=" text-decoration-none  d-inline-block"
                >
                  <Image src={RegisterLogo} alt="Site-Logo" />
                </Link>
              </h1>
              <div className="mb-4 welcome-content">
                <h4 className="mb-1 fw-medium text-start">Let's Sign Up</h4>
                <p className="text-start">
                  Make your app management easy and fun!
                </p>
              </div>

              <Formik
                initialValues={initialEventState}
                validationSchema={registerSchema}
                onSubmit={handleSubmit}
              >
                {({
                  errors,
                  touched,
                  isSubmitting,
                  handleChange,
                  values,
                  setFieldValue,
                  handleSubmit,
                }) => (
                  <>
                    {/* {console.log("errors:: ",errors)}  */}
                    {/* {console.log("values:: ", values)}

                    {/* {console.log("touched:: ",touched)} */}
                    {/* <pre>
                  {JSON.stringify({ errors, touched}, null, 2)}
                </pre> */}
                    <Form onSubmit={handleSubmit}>
                      <Row className="mb-3">
                        <Col md={6}>
                          <CommonFormLabel title="Name" />
                          <Input
                            id="name"
                            name="name"
                            type="text"
                            placeholder="John Doe"
                            onChange={handleChange}
                            className={`shadow-none ${
                              touched.name && errors.name ? "error" : "correct"
                            }`}
                          />
                          {touched.name && errors.name ? (
                            <ValidationFeedback title={errors.name} />
                          ) : null}
                        </Col>

                        <Col md={6}>
                          <CommonFormLabel title="Designation" />
                          <Input
                            id="designation"
                            name="designation"
                            type="text"
                            placeholder="Manager"
                            onChange={handleChange}
                            className={`shadow-none ${
                              touched.designation && errors.designation ? "error" : "correct"
                            }`}
                          />
                          {touched.designation && errors.designation ? (
                            <ValidationFeedback title={errors.designation} />
                          ) : null}
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={12}>
                          <SimpleDropdown
                            label="Bank Name"
                            name="bank_id"
                            value={values.bank_id}
                            onChange={(selectedOption) => {
                              setFieldValue("bank_id", selectedOption.value);
                              setSelectedBankId(selectedOption.value);
                            }}
                            options={bankOptions}
                            placeholder="Select a Bank"
                            error={errors?.bank_id}
                            touched={touched?.bank_id}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">                 
                        <Col md={6}>
                          <SimpleDropdown
                            label="Branch"
                            name="branch_id"
                            value={values.branch_id}
                            onChange={(selectedOption) => {
                              setFieldValue("branch_id", selectedOption.value);
                              // setSelectedBranchId(selectedOption.value);
                            }}
                            options={branchOptions}
                            placeholder="Select a Branch"
                            error={errors?.branch_id}
                            touched={touched?.branch_id}
                            isDisabled={!selectedBankId}
                          />
                        </Col>
                       
                        <Col md={6}>
                          <SimpleDropdown
                            label="State"
                            name="state"
                            value={values.state}
                            onChange={(selectedOption) => {
                              setFieldValue("state", selectedOption.value);
                              setSelectedStateId(selectedOption.value);
                            }}
                            options={stateList}
                            placeholder="Select a State"
                            error={errors?.state}
                            touched={touched?.state}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                      <Col md={6}>
                          <CommonFormLabel title="Email" />
                          <Input
                            id="email"
                            name="email"
                            type="email"
                            placeholder="johndoe@gmail.com"
                            onChange={handleChange}
                            className={`shadow-none ${
                              touched.email && errors.email
                                ? "error"
                                : "correct"
                            }`}
                          />
                          {touched.email && errors.email ? (
                            <ValidationFeedback title={errors.email} />
                          ) : null}
                        </Col>
                        <Col md={6}>
                          <SimpleDropdown
                            label="City"
                            name="city"
                            value={values.city}
                            onChange={(selectedOption) => {
                              setFieldValue("city", selectedOption.value);
                              // setSelectedBankId(selectedOption.value);
                            }}
                            options={cityList}
                            placeholder="Select a City"
                            error={errors?.state}
                            touched={touched?.state}
                            isDisabled={!selectedStateId}
                          />
                        </Col>
                      </Row>

                      <Row className="mb-3">
                        <Col md={6}>
                          <CommonFormLabel title="Mobile Number" />
                          <Input
                            id="phone"
                            name="phone"
                            type="text"
                            placeholder="9876543210"
                            onChange={handleChange}
                            className={`shadow-none ${
                              touched.phone && errors.phone
                                ? "error"
                                : "correct"
                            }`}
                          />
                          {touched.phone && errors.phone ? (
                            <ValidationFeedback title={errors.phone} />
                          ) : null}
                        </Col>     
                      </Row>
                      
                       
                      <Col md={12}>
                          <CommonFormLabel title="Password" />
                          <div className="position-relative">
                            <Input
                              id="password"
                              name="password"
                              type={showEyeIcon ? "password" : "text"}
                              placeholder="*************"
                              onChange={handleChange}
                              className={`shadow-none ${
                                touched.password && errors.password
                                  ? "error"
                                  : "correct"
                              }`}
                            />
                            <div className="position-absolute top-50 end-0 translate-middle-y me-3 cursor-pointer">
                              {showEyeIcon === false ? (
                                <ViewOffSlashIcon
                                  width={20}
                                  height={20}
                                  color="#444050"
                                  strokeWidth="1.5"
                                  className={
                                    touched.password && errors.password
                                      ? "error"
                                      : "correct"
                                  }
                                  onClick={() => setShowEyeIcon(true)}
                                />
                              ) : (
                                <EyeIcon
                                  width={20}
                                  height={20}
                                  color="#444050"
                                  strokeWidth="1.5"
                                  className={`${
                                    touched.password && errors.password
                                      ? "error"
                                      : "correct"
                                  }`}
                                  onClick={() => setShowEyeIcon(false)}
                                />
                              )}
                            </div>
                          </div>
                          {touched.password && errors.password ? (
                            <ValidationFeedback title={errors.password} />
                          ) : null}
                      </Col>

                      <div className="text-center mt-5" style={{ width: "70%", margin: "0 auto" }}>
                        <CommonButton title="Sign Up" type="submit" disabled={isSubmitting} className="w-100 btn-primary primary-shadow"/>
                      </div>
                      <div className="mb-0 welcome-content d-flex align-items-center justify-content-center gap-2 mt-4">
                        <p>Already have an account?</p>
                        <div className="register-link">
                          <Link to="/login" className="text-decoration-none register-link">
                            Sign in instead
                          </Link>
                        </div>
                      </div>
                    </Form>
                  </>
                )}
              </Formik>

              {/* <div className="d-flex align-items-center mb-1">
                <input type="checkbox" />
                <div className="mb-4 mx-2 welcome-content d-flex align-items-center justify-content-center gap-2 mt-4">
                  <p className="">I agree to</p>
                  <div className="register-link">
                    <Link
                      to="/login"
                      className="text-decoration-none register-link"
                    >
                      privacy policy & terms
                    </Link>
                  </div>
                </div>
                {/* {touched.email && errors.email ? (
                      <ValidationFeedback title={errors.email} />
                    ) : null} */}
              {/* </div>  */}
            </div>
          </div>
        </div>
      </Container>
    </>
  );
};

export default Register;
